import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private _error?: HttpErrorResponse;

  /**
   * Setzt ein Error, wenn der Request fehlschlägt
   *
   * @param error
   */
  setError(error: HttpErrorResponse): void {
    this._error = error;
  }

  /**
   * Gibt ein Error zurück
   */
  getError(): HttpErrorResponse | undefined {
    return this._error;
  }
}
